export default __webpack_public_path__ + "static/media/sample_site_AdobeCreativeCloudExpress.b75b2a10.mp4";